<template>
  <!--<div class="triplet__right">-->
  <div class="maps__col maps__col--comments">
    <div class="switchers-bottom-fixed__container" ref="texts">
      <div v-if="currentArea && buttons.length !== 0">
        <strong>{{ currentArea.name }}</strong>
      </div>
      <div
        class="row-buttons-tiles"
        :class="{ 'row-buttons-tiles--column': displayRowInColumns }"
        v-resized="resizeHandler()"
      >
        <div class="col-left" v-if="buttons.length !== 0">
          <WizardEventDispatcher
            :event="'click'"
            :target="{ type: 'custom-button', id: button.id }"
            v-for="button in buttons"
            :key="button.id"
          >
            <CustomButton
              :areaId="button.areaId"
              :title="button.title"
              :fontSize="button.style_fontSize"
              :textColor="button.style_textColor"
              :fontWeight="button.style_fontWeight"
              :backgroundColor="button.style_bgColor"
              :destination="button.destination"
            ></CustomButton>
          </WizardEventDispatcher>
        </div>
        <div class="col-right">
          <LayerImageTiles :orderedLayers="orderedLayers" />
        </div>
      </div>

      <strong>Texty</strong>

      <LayerTexts
        v-for="sl in orderedLayers"
        :key="sl.id"
        :layer="sl"
        :subLayers="layers.subLayers[sl.id]"
        :openedLayers="openLayersParsed"
      ></LayerTexts>
      <div class="switchers-bottom-fixed">
        <ToggleCommentPins style="margin-bottom: 0.5rem;" />
        <ToggleSwitch layout-part="phasesTimeline"
          >Fáze &amp; Další vrstvy</ToggleSwitch
        >
      </div>
    </div>
  </div>
</template>

<script>
import LayerTexts from '@/components/LayerTexts.vue';
import ToggleSwitch from '@/components/ToggleSwitch.vue';
import CustomButton from '@/components/CustomButton.vue';
import WizardEventDispatcher from '@/components/wizard/WizardEventDispatcher.vue';
import LayerImageTiles from '@/components/sidebar/LayerImageTiles.vue';
import ToggleCommentPins from '@/components/sidebar/ToggleCommentPins.vue';

import naja from 'naja';
import { mapState, mapActions, mapGetters } from 'vuex';
import resized from 'vue-resize-directive';
// import CommentService from '@/services/CommentService';
// import _ from 'lodash';

export default {
  props: {
    orderedLayers: {
      type: Array,
      required: true
    }
  },
  directives: {
    resized
  },
  components: {
    LayerTexts,
    ToggleSwitch,
    CustomButton,
    LayerImageTiles,
    ToggleCommentPins,
    WizardEventDispatcher
  },
  data() {
    return {
      allCommentsActive: false,
      allCommentsLoading: false,
      singleCommentActive: false,
      minRowInColumnsWidth: 450,
      displayRowInColumns: false
    };
  },
  computed: {
    ...mapState(['general', 'layers']),
    ...mapActions([
      'general/setControlsRight',
      'general/setSingleCommentStatus'
    ]),
    ...mapGetters({
      buttons: ['general/buttonsAboveText'],
      currentArea: ['general/currentArea']
    }),

    openLayersParsed: function () {
      return JSON.parse(this.$route.params.openTexts);
    }
  },
  // mounted: function () {
  //   // Get comments for this layer + all sublayers
  //   let allLayerIds = [];
  //   _.forEach(this.layers.layers, (layer) => {
  //     allLayerIds.push(layer.id);
  //   });
  //   _.forEach(this.layers.subLayers, (sublayersList) => {
  //     allLayerIds = _.concat(allLayerIds, sublayersList);
  //   });

  //   CommentService.getCommentsByIds(JSON.stringify(allLayerIds))
  //     .then((result) => {
  //       if (result.data) {
  //         console.log(result.data, 'getCommentsByIds');
  //         // this.comments = result.data;
  //       }
  //     })
  //     .catch(() => {});
  // },
  methods: {
    setControlsRight(controls) {
      this.$store.dispatch('general/setControlsRight', controls);
    },
    loadAllComments(e) {
      e.preventDefault();
      this.allCommentsLoading = true;
      naja.makeRequest('GET', '?do=allcomments').then((result) => {
        this.allCommentsActive = true;
        this.allCommentsLoading = false;
      });
    },
    goBack(e) {
      e.preventDefault();

      naja.makeRequest('GET', '?do=commentsBack').then(() => {
        this.allCommentsActive = false;
        this.$store.dispatch('general/setSingleCommentStatus', false);
      });
    },
    resizeHandler() {
      const rowEl = document.getElementsByClassName('row-buttons-tiles')[0];
      if (rowEl) {
        this.displayRowInColumns =
          rowEl.offsetWidth < this.minRowInColumnsWidth;
      }
    }
  },
  watch: {
    'general.layout.sidebarLeft'(newValue) {
      if (!newValue) {
        this.$refs.texts.scrollIntoView();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.switchers-bottom-fixed__container {
  position: relative;
  padding-bottom: 3.5rem;
  min-height: 100%;
}
.switchers-bottom-fixed {
  /* position: absolute; */
  bottom: 0.5rem;
  padding-top: 2rem;
}

.row-buttons-tiles {
  display: flex;
  flex: 1;
  width: 100%;

  & .col-left {
    padding-bottom: 1rem;
    padding-right: 1.5rem;
  }

  & .col-right {
    overflow-x: auto;
    display: flex;
    align-items: center;
  }

  &--column {
    flex-direction: column-reverse;

    & .col-left {
      padding-right: 0;
    }
  }
}
</style>
